export const allDonationTypesInitialState: any = {
	loading: false,
	error: null,
	data: null,
};
